import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { colors } from "../../theme/theme";
import ImageSlider from "../../Components/Product/ImageSlider";
import CustomAccordion from "../../Components/Common/CustomAccordion";
import Footer from "../../Components/Common/Footer";
import { useLocation } from "react-router-dom";
import SizeSelector from "../../Components/Product/SizeSelector";
import { logUserAction } from "../../utils/analytics";

const ProductPage = () => {
  const location = useLocation();
  const searchQuery = location.state?.searchQuery || "";
  const product = location.state?.product || {};

  const [openIndexes, setOpenIndexes] = useState([0, 1, 2]);

  const toggleAccordion = (index) => {
    setOpenIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }, []);

  return (
    <Box sx={{ backgroundColor: "#F8F8F8" }}>
      <Stack direction={smallScreen ? "column" : "row"}>
        <ImageSlider
          productImages={
            product?.images?.length > 0
              ? product?.images
              : [product?.image_url] || []
          }
          searchQuery={searchQuery}
        />
        <Box
          sx={{
            mt: 2,
            mx: 2,
            pt: 2,
            width: smallScreen ? "null" : "47.5%",
            borderRadius: "20px",
            backgroundColor: "#fff",
            boxShadow: "-1px -2px 15px 0px #00000012",
          }}
        >
          {product?.price?.sale_percentage != null && (
            <Box
              sx={{
                position: "absolute",
                top: "20px",
                right: "10px",
                backgroundColor: "#ABCC8C",
                color: colors.textColor,
                borderBottomLeftRadius: "20px",
                padding: "5px 11px",
                fontSize: "12px",
                fontFamily: "Poppins-Bold",
                zIndex: 1,
                mb: 2,
              }}
            >
              {product?.price?.sale_percentage} % Off
            </Box>
          )}

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "left",
              mx: 2,
            }}
          >
            <Box
              sx={{
                backgroundColor: "#9AE0EB",
                borderRadius: "4px",
                padding: "3px 6px",
                width: "fit-content",
                minWidth: "fit-content",
                fontSize: "12px",
              }}
            >
              {product?.brand}
            </Box>
            <Typography
              sx={{
                color: "#2E2E2E",
                fontFamily: "Poppins-Regular",
                fontWeight: "400",
                fontSize: "22px",
                mt: 1,
              }}
            >
              {product?.title}
            </Typography>
          </Box>

          {/* Color Selection */}
          {/* <ColorSelector /> */}

          {/* Size Selector */}
          {product?.variants?.length > 0 && (
            <Box sx={{ mx: 2, mt: 3 }}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography
                  sx={{
                    fontFamily: "Poppins-Medium",
                    color: colors.textColor3,
                  }}
                >
                  SIZE
                </Typography>
                {/* <Typography
              sx={{
                fontFamily: "Poppins-Medium",
                color: colors.textColor3,
                opacity: 0.35,
                textDecorationLine: "underline",
                fontSize: "12px",
              }}
            >
              SIZE GUIDE
            </Typography> */}
              </Stack>
              <SizeSelector
                sizes={[
                  ...new Map(
                    product?.variants?.map((v) => [
                      v.size,
                      { size: v.size, available: v.available },
                    ])
                  ).values(),
                ]}
              />
            </Box>
          )}

          {/* Button */}
          <Box
            sx={{
              width: "90%",
              backgroundColor: "#FBD179",
              my: 4,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              py: 1.5,
              mx: "auto",
              cursor: "pointer",
              transition: "all 0.3s ease-in-out",
              "&:active": {
                transform: "scale(0.9)",
              },
            }}
            onClick={async () => {
              await logUserAction({
                action: "checkout_redirect",
                data: {
                  product_id: product?.product_id || "",
                  product_title: product?.title || "",
                  brand: product?.brand || "",
                  redirect_url: product?.url || null,
                },
                timestamp: new Date().toISOString(),
              });
              if (product?.url) {
                window.open(product.url, "_blank");
              }
            }}
          >
            <Typography
              sx={{
                fontFamily: "Poppins-Medium",
                color: "#3C3C3C",
                fontSize: "14px",
              }}
            >
              {`Buy on ${product?.brand}`}
            </Typography>
          </Box>

          <CustomAccordion
            title="Product Description"
            content={product?.description}
            isOpen={openIndexes.includes(0)}
            toggle={() => toggleAccordion(0)}
          />

          {product?.attributes && (
            <CustomAccordion
              title="Product Info"
              content={product?.attributes?.inventory_text}
              isOpen={openIndexes.includes(1)}
              toggle={() => toggleAccordion(1)}
            />
          )}

          <CustomAccordion
            title="Price"
            content={
              <>
                Discounted: {product?.price?.currency}{" "}
                {product?.price?.discounted} /-
                <br />
                <br />
                {product?.price?.sale_percentage != null &&
                  `Original: ${product?.price?.currency} ${product?.price?.original} /-`}
              </>
            }
            isOpen={openIndexes.includes(2)}
            toggle={() => toggleAccordion(2)}
          />
        </Box>
      </Stack>
      <Footer />
    </Box>
  );
};

export default ProductPage;
